import React, { Component } from 'react'
import Checkbox from './Checkbox'

export default class CheckboxLine extends Component {
    render() {
        const { checkboxProps = {}, content, hideCheckbox = false } = this.props;
        return (
            <div className="checkbox-line">
                {
                    Array.isArray(content) ? content.map((item, i) => {
                        return <div key={i}>{item}</div>
                    })
                    :
                    content
                }
                { !hideCheckbox && <Checkbox {...checkboxProps} /> }
            </div>
        )
    }
}
